import { ConfigProvider } from 'antd'
import GlobalLayout from './components/globalLayout/globalLayout'
import NotificationProvider from './utils/notificationProvider'
import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

function App() {
  /*=========== Reset URL After Reload =====================*/
  const navigate = useNavigate()
  useEffect(() => {
    const [nav] = performance.getEntriesByType('navigation')

    if (nav?.type === 'reload' || nav?.type === 'navigate') {
      navigate('/', { replace: true })
    }
  }, [])
  /*========================================================*/
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#27A6A4',
          fontFamily: 'Open Sans'
        }
      }}
    >
      <NotificationProvider>
        <div className="App">
          <GlobalLayout></GlobalLayout>
        </div>
      </NotificationProvider>
    </ConfigProvider>
  )
}

export default App
